import { useFormatMessage } from '../../intl/intl'

export function useOutStockText({ ctaName }) {
  const cta = useFormatMessage({ id: `menuBoard.outOfStock.${ctaName}` })
  return cta
}
